import { Component, OnDestroy, OnInit } from "@angular/core";
import { Subject, takeUntil } from "rxjs";
import { GetFilterdContactsResponseDTO } from "../../../../models/contact.model";
import { ContactService } from "../../../../contact.service";

@Component({
  selector: "app-create-contact-list-table",
  templateUrl: "./create-contact-list-table.component.html",
  styleUrl: "./create-contact-list-table.component.scss",
})
export class CreateContactListTableComponent implements OnInit, OnDestroy {
  private readonly destroy$ = new Subject<void>();
  data!: GetFilterdContactsResponseDTO;
  isLoading = false;
  private atualizandoProgramaticamente = false;

  constructor(
    private contactService: ContactService,
  ) {}

  ngOnInit(): void {
    this.contactService.loading.pipe(takeUntil(this.destroy$)).subscribe({
      next: (loading) => {
        this.isLoading = loading;
      },
    });
    this.contactService
      .getContactFilters()
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (contacts) => {
          this.data = contacts;
          // Atualizar paginação após resposta da API
          if (this.data && this.data.paginacao) {
            this.atualizandoProgramaticamente = true;
            setTimeout(() => {
              this.atualizandoProgramaticamente = false;
            }, 100);
          }
        },
        error: (error) => {
          console.error("Erro ao buscar contatos:", error);
        },
      });
  }

  onChangePage(page: number): void {
    if (!this.atualizandoProgramaticamente) {
      this.contactService.setFilters({
        "Paginacao.PaginaAtual": page.toString(),
      });
    }
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
